import { render } from "./CommonAlert.vue?vue&type=template&id=a2a3eb1c&scoped=true"
import script from "./CommonAlert.vue?vue&type=script&lang=js"
export * from "./CommonAlert.vue?vue&type=script&lang=js"

import "./CommonAlert.vue?vue&type=style&index=0&id=a2a3eb1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a3eb1c"]])

export default __exports__